import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';
import { ApiErrorHandler } from '../error.handler';
import { OtpApiResponse } from '../../../types/otp';

class OtpEndpoint extends BaseEndpoint {
  private static instance: OtpEndpoint;

  private constructor() {
    super('organisations');
  }

  static getInstance(): OtpEndpoint {
    if (!OtpEndpoint.instance) {
      OtpEndpoint.instance = new OtpEndpoint();
    }
    return OtpEndpoint.instance;
  }

  async sendOtp(organisationId: string, phoneNumber: string): Promise<OtpApiResponse['data']> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<OtpApiResponse>(
        `${this.basePath}/${organisationId}/twilio/sendotp`,
        { phoneNumber },
        { headers }
      );

      logger.info('OTP sent successfully', { phoneNumber });
      return response.data.data;
    } catch (error) {
      logger.error('Failed to send OTP:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async verifyOtp(
    organisationId: string,
    phoneNumber: string,
    otp: string
  ): Promise<OtpApiResponse['data']> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<OtpApiResponse>(
        `${this.basePath}/${organisationId}/twilio/verifyotp`,
        { phoneNumber, otp },
        { headers }
      );

      logger.info('OTP verified successfully', { phoneNumber });
      return response.data.data;
    } catch (error) {
      logger.error('Failed to verify OTP:', error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const otpEndpoint = OtpEndpoint.getInstance();
